<div class="sub-header">
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb></app-breadcrumb>
      </div>

      <div class="col-5 text-right">
        <app-search-bar [showSearchBarInput]="false"/>
      </div>
    </div>

    <div class="row">
      <div class="col">
      </div>

      <div class="col text-center">
      </div>

      <div class="col-5 d-flex justify-content-between flex-wrap">
        <app-search-filters-dropdown  [showFavorite]="false" [showCustomFilters]="false"/>
      </div>
    </div>
  </div>
</div>
